import { IVersionsResponse } from './types';
import api from "../api"

export type homePageParams = {
  version: string | null,
  client: string | null,
}

export const getVersions = (params: homePageParams) => api.get<IVersionsResponse>('/api/versions/',{
  params: {
    version: params.version ? params.version : '',
    client: params.client ? params.client : '',
  }
}).then(({data}) => (data));